import styled from "styled-components";
import { AllieList } from "../../../components/List";
import { AllieItem } from "../../../components/Item/Item";
import { AllieLabel } from "../../../components/Item/Label";

export const AllieListStyled = styled(AllieList)`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  padding: 0;
`;

export const AllieItemStyled = styled(AllieItem)`
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
  &&&&{--background-hover: none};
  &&&&{--ripple-color: transparent};
`;

export const AllieLabelStyled = styled(AllieLabel)`
  &&&&{transform: translateY(0)};
  &&&&{color: var(--allie-color-neutral-70)};
`;